"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface UseOfAuditorsSpecialistTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "uas-1",
    question: "Have we used any of the following in the audit?",
    type: "checkbox",
    options: ["Internal Specialist", "External Specialist"],
  },
  {
    id: "uas-2",
    question: "Document our evaluation whether the expert has the necessary competence, capabilities and objectivity for the auditor's purposes. In the case of an external expert, the evaluation of objectivity shall include inquiry regarding interests and relationships that may create a threat to that expert's objectivity.",
    type: "document",
  },
  {
    id: "uas-3",
    question: "Based on our evaluation of the expert's work, have we determined the expert's work as adequate for our purpose?",
    type: "radio",
    options: ["Yes, it is adequate", "No, it is not adequate"],
    guidance: {
      text: "Specific procedures to evaluate the adequacy of the auditor's expert's work for the auditor's purposes may include:",
      items: [
        "Inquiries of the auditor's expert.",
        "Reviewing the auditor's expert's working papers and reports.",
        "Corroborative procedures such as:\n\ti. Observing the auditor's expert's work;\n\tii. Examining published data, such as statistical reports from reputable, authoritative sources;\n\tiii. Confirming relevant matters with third parties;\n\tiv. Performing detailed analytical procedures; and\n\tv. Re-performing calculations.",
        "Discussion with another expert with relevant expertise when, for example, the findings or conclusions of the auditor's expert are not consistent with other audit evidence.",
        "Discussing the auditor's expert's report with management.",
      ],
    },
    follow_up: {
      condition: "No, it is not adequate",
      id: "uas-3-followup",
      question: "If Inadequate, Document our procedures for the following:\n\ti. Agreeing with the expert on the nature and extent of further work to be performed by that expert; or\n\tii. Perform further audit procedures appropriate to the circumstances.",
      type: "document",
    },
  },
];

export default function UseOfAuditorsSpecialistTailoringQuestions({ onBack }: UseOfAuditorsSpecialistTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Use of Auditor's Specialist"
      title="Use of Auditor's Specialist - Tailoring Questions"
      description="Answer entity-specific questions for Use of Auditor's Specialist"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
